/**
 * First Class Property Management — theme.js
 */
(function () {
  'use strict';

  /* Init on DOMContentLoaded AND on Shopify section:load event (Theme Editor) */
  var _initialized = false;
  function initAll() {
    if (_initialized) return;
    _initialized = true;
    initNavOverlay();
    initOnboardingCarousel();
    initTestimonialCarousel();
    initScrollReveal();
    initCounters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Re-init when Shopify Theme Editor reloads a section */
  document.addEventListener('shopify:section:load', function () {
    _initialized = false;
    initAll();
  });

  /* ─── NAV OVERLAY (pill hamburger → slide panel) ─── */
  function initNavOverlay() {
    var hamburger = document.getElementById('hamburger');
    var overlay   = document.getElementById('nav-overlay');
    var closeBtn  = document.getElementById('nav-close');
    var backdrop  = document.getElementById('nav-backdrop');
    if (!hamburger || !overlay) return;

    /* Always move overlay to <body> — avoids position:fixed parent traps */
    if (overlay.parentElement !== document.body) {
      document.body.appendChild(overlay);
      /* Re-fetch refs after move */
      closeBtn = document.getElementById('nav-close');
      backdrop = document.getElementById('nav-backdrop');
    }

    function openMenu() {
      overlay.setAttribute('aria-hidden', 'false');
      hamburger.setAttribute('aria-expanded', 'true');
      hamburger.classList.add('is-active');
      document.body.style.overflow = 'hidden';
    }

    function closeMenu() {
      overlay.setAttribute('aria-hidden', 'true');
      hamburger.setAttribute('aria-expanded', 'false');
      hamburger.classList.remove('is-active');
      document.body.style.overflow = '';
    }

    /* Remove old listeners before adding new ones (safe for re-init) */
    var newHamburger = hamburger.cloneNode(true);
    hamburger.parentNode.replaceChild(newHamburger, hamburger);
    hamburger = newHamburger;

    hamburger.addEventListener('click', function () {
      overlay.getAttribute('aria-hidden') === 'true' ? openMenu() : closeMenu();
    });

    if (closeBtn) {
      var newClose = closeBtn.cloneNode(true);
      closeBtn.parentNode.replaceChild(newClose, closeBtn);
      newClose.addEventListener('click', closeMenu);
    }

    if (backdrop) backdrop.addEventListener('click', closeMenu);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMenu();
    });

    /* Smooth scroll for anchor links (#section-id) and auto-close menu */
    overlay.querySelectorAll('a[href]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var href = link.getAttribute('href');
        closeMenu();
        if (href && href.charAt(0) === '#') {
          e.preventDefault();
          var target = document.getElementById(href.slice(1));
          if (target) {
            setTimeout(function () {
              target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 350); /* wait for menu close animation */
          }
        }
      });
    });
  }

  /* ─── ONBOARDING CAROUSEL ─── */
  function initOnboardingCarousel() {
    var track     = document.getElementById('onboarding-track');
    var prevBtn   = document.getElementById('onboarding-prev');
    var nextBtn   = document.getElementById('onboarding-next');
    if (!track) return;

    var cards       = track.querySelectorAll('.onboarding-step');
    var total       = cards.length;
    var current     = 0;
    var perView     = getPerView();
    var maxIndex    = total - perView;

    function getPerView() {
      if (window.innerWidth <= 600)  return 1;
      if (window.innerWidth <= 900)  return 2;
      return 3;
    }

    function getCardWidth() {
      if (!cards[0]) return 0;
      return cards[0].getBoundingClientRect().width + 16; /* width + gap */
    }

    function update() {
      perView  = getPerView();
      maxIndex = Math.max(0, total - perView);
      current  = Math.min(current, maxIndex);
      var offset = current * getCardWidth();
      track.style.transform = 'translateX(-' + offset + 'px)';
      if (prevBtn) prevBtn.disabled = current <= 0;
      if (nextBtn) nextBtn.disabled = current >= maxIndex;
    }

    if (prevBtn) prevBtn.addEventListener('click', function () {
      if (current > 0) { current--; update(); }
    });

    if (nextBtn) nextBtn.addEventListener('click', function () {
      if (current < maxIndex) { current++; update(); }
    });

    /* Touch swipe */
    var startX = 0;
    track.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
    }, { passive: true });

    track.addEventListener('touchend', function (e) {
      var diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) {
        if (diff > 0 && current < maxIndex) { current++; update(); }
        if (diff < 0 && current > 0)        { current--; update(); }
      }
    }, { passive: true });

    /* Resize */
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(update, 200);
    });

    update();
  }

  /* ─── TESTIMONIAL CAROUSEL ─── */
  function initTestimonialCarousel() {
    var track         = document.getElementById('testimonials-track');
    var dotsContainer = document.getElementById('testimonials-dots');
    var prevBtn       = document.getElementById('prev-testimonial');
    var nextBtn       = document.getElementById('next-testimonial');
    if (!track || !dotsContainer) return;

    var cards       = track.querySelectorAll('.testimonial-card');
    var total       = cards.length;
    var current     = 0;
    var visible     = getVisible();
    var autoInterval;

    function getVisible() {
      return window.innerWidth <= 768 ? 1 : 2;
    }

    function update() {
      visible  = getVisible();
      var max  = total - visible;
      current  = Math.min(current, max);
      cards.forEach(function (c, i) {
        c.style.display = (i >= current && i < current + visible) ? '' : 'none';
      });
      buildDots(max);
    }

    function buildDots(max) {
      dotsContainer.innerHTML = '';
      for (var i = 0; i <= max; i++) {
        (function (idx) {
          var dot = document.createElement('button');
          dot.className = 'testimonials__dot' + (idx === current ? ' is-active' : '');
          dot.setAttribute('aria-label', 'Slide ' + (idx + 1));
          dot.addEventListener('click', function () { current = idx; update(); resetAuto(); });
          dotsContainer.appendChild(dot);
        })(i);
      }
    }

    function next() { var max = total - visible; current = current >= max ? 0 : current + 1; update(); }
    function prev() { var max = total - visible; current = current <= 0 ? max : current - 1; update(); }
    function startAuto() { autoInterval = setInterval(next, 5500); }
    function resetAuto() { clearInterval(autoInterval); startAuto(); }

    if (nextBtn) nextBtn.addEventListener('click', function () { next(); resetAuto(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); resetAuto(); });

    var tStartX = 0;
    track.addEventListener('touchstart', function (e) { tStartX = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend',   function (e) {
      var diff = tStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) { diff > 0 ? next() : prev(); resetAuto(); }
    }, { passive: true });

    var rTimer;
    window.addEventListener('resize', function () { clearTimeout(rTimer); rTimer = setTimeout(update, 200); });

    update();
    startAuto();
  }

  /* ─── SCROLL REVEAL ─── */
  function initScrollReveal() {
    var els = document.querySelectorAll('[data-reveal]');
    if (!els.length || !window.IntersectionObserver) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -60px 0px', threshold: 0.1 });

    els.forEach(function (el) { observer.observe(el); });
  }

  /* ─── ANIMATED COUNTERS ─── */
  function initCounters() {
    var els = document.querySelectorAll('.stat-item__value');
    if (!els.length || !window.IntersectionObserver) return;

    function animateCounter(el) {
      var text  = el.textContent.trim();
      var match = text.match(/^([\d,]+)/);
      if (!match) return;
      var target   = parseInt(match[1].replace(/,/g, ''), 10);
      var suffix   = text.replace(match[1], '');
      var duration = 1800;
      var start    = performance.now();

      function tick(now) {
        var p = Math.min((now - start) / duration, 1);
        var e = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.floor(e * target).toLocaleString() + suffix;
        if (p < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { animateCounter(entry.target); obs.unobserve(entry.target); }
      });
    }, { threshold: 0.5 });

    els.forEach(function (el) { obs.observe(el); });
  }

})();
